const flyoutBannerSecondaryMixin = {
  methods: {
    showFlyoutSecondary(status, message, autoDismiss, timer) {
      this.$root.$refs.flyoutBannerSecondary.showFlyoutSecondary({
        status,
        message,
        autoDismiss,
        timer,
      });
    },
    dismissFlyoutSecondary() {
      this.$root.$refs.flyoutBannerSecondary.dismissFlyoutSecondary();
    },
    showFlyoutNextPageSecondary(status, message, autoDismiss) {
      this.$root.$refs.flyoutBannerSecondary.showFlyoutNextPageSecondary({
        status,
        message,
        autoDismiss,
      });
    },
  },
};

export default flyoutBannerSecondaryMixin;



// WEBPACK FOOTER //
// ./src/components/common/vx-flyout-banner-secondary/vx-flyout-banner-secondary-mixin.js